import * as React from 'react';
import { useId } from 'react';
import Svg, { ClipPath, Defs, G, Path, Rect, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

const SvgComponent = (props: SvgProps) => {
    const uid = useId();
    const clipId = `${uid}-clip`;

    return (
        <Svg width={props.width || 16} height={props.height || 16} viewBox="0 0 16 16" fill="none" {...props}>
            <G clipPath={`url(#${clipId})`}>
                <Path
                    d="M11.5399 3.12988L13.9403 3.66016L13.7098 6.12988L15.3397 8L13.7098 9.87012L13.9403 12.3398L11.5399 12.8701L10.2704 15L7.99988 14.0303L5.73035 15L4.45984 12.8701V12.8604L2.06042 12.3301L2.28992 9.86035L0.660034 7.99023L2.28992 6.12988L2.06042 3.66016L4.45984 3.12988L5.73035 1L7.99988 1.96973L10.2704 1L11.5399 3.12988ZM10.7802 5.14941C10.6002 5.23941 9.85987 5.68961 8.99988 6.34961C8.22988 6.93961 7.35031 7.72008 6.69031 8.58008C6.54031 8.30008 6.37035 8.02957 6.23035 7.80957C6.12035 7.65957 6.02984 7.51969 5.95984 7.42969C5.92987 7.37978 5.89974 7.3493 5.87976 7.31934C5.87063 7.30978 5.86155 7.28413 5.86023 7.28027H5.85046L5.67957 7.0498L5.49988 7.26953L4.63953 8.31934L4.50964 8.47949L4.65027 8.62012C5.13992 9.13984 5.44954 9.70957 5.63953 10.1494C5.72945 10.3692 5.79991 10.5595 5.82996 10.6895C5.84992 10.7593 5.87966 10.8096 5.87976 10.8496C5.87976 10.8591 5.88867 10.8782 5.88953 10.8799V10.8994L5.92957 11.0693H7.32996L7.37976 10.9102C7.78976 9.38016 8.72996 8.08969 9.57996 7.17969C9.9998 6.72986 10.3896 6.37986 10.6796 6.12988C10.8296 6.00988 10.9502 5.91937 11.0302 5.85938C11.0689 5.83027 11.1172 5.79223 11.12 5.79004L11.1395 5.76953C11.1495 5.76953 11.1503 5.75977 11.1503 5.75977L11.3202 5.64941L11.2196 5.46973L11.08 5.24023L10.9696 5.0498L10.7802 5.14941Z"
                    fill={props.color || designSystem.colors.neutral800}
                />
            </G>
            <Defs>
                <ClipPath id={clipId}>
                    <Rect
                        width={14.67}
                        height={14}
                        fill={ds.colorValue.icon.primary}
                        transform="translate(0.660034 1)"
                    />
                </ClipPath>
            </Defs>
        </Svg>
    );
};
export { SvgComponent as FreePickIcon };
